import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionMain extends ThemeComponent {
    @Ref productGrid!: HTMLElement;
    @Ref({required: false}) productCountLabel!: HTMLElement; // Add a reference for the product count label
    @Ref({required: false}) loadMore!: HTMLButtonElement;
    @Ref({required: false}) loadingBar!: HTMLElement;
    @Prop total!: string;
    @Prop totalPages!: string;
    private currentPage = 1;
    private totalPagesNumber = 0;

    init() {
        this.totalPagesNumber = parseInt(this.totalPages, 10) || 0; // Handle undefined or NaN values

        if (this.loadMore) {
            this.$listen(this.loadMore, 'click', () => {
                if (this.currentPage < this.totalPagesNumber) {
                    this.currentPage++;
                    this.loadMoreProducts(this.currentPage);
                    this.loadMore.blur();

                    if (this.currentPage == this.totalPagesNumber) {
                        this.loadMore.style.display = "none";
                    }
                }
            });
        }

        document.addEventListener('gridSwitchLoaded', () => { this.productGrid.classList.remove('is-hidden'); });
    }

    private loadMoreProducts(page: number) {
        const url = window.location.href;
        const query = `${window.location.href.indexOf("?") > -1 ? '&':'?'}page=${page}`;

        fetch(url + query)
            .then((response) => response.text())
            .then((data) => {
                const parser = new DOMParser();
                const html = parser.parseFromString(data, 'text/html');
                const newProducts = html.getElementById('collection-items')?.innerHTML;

                if (newProducts) {
                    this.productGrid.insertAdjacentHTML('beforeend', newProducts);

                    // Update product count label
                    let newProductCount = this.currentPage * 16; // Assuming 16 products per page
                    if (newProductCount > parseInt(this.total, 10)) {
                        newProductCount = parseInt(this.total, 10);
                    }
                    if(this.loadingBar) {
                        const barWidth: number = (this.currentPage / this.totalPagesNumber) * 100;
                        this.loadingBar.style.width = `${barWidth}%`;
                    }
                    if (!this.productCountLabel) { return; }
                    this.productCountLabel.textContent = `Showing ${newProductCount} of ${this.total}`;
                }
            })
            .catch((error) => {

            });
    }
}
